module.exports = __webpack_public_path__ + "img/car-5.599c78ea.jpg";